'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('./../../../external/classnames/index.js');
var arrow_right_inline = require('../../../assets/svg/arrow_right.inline.svg.js');
var index$1 = require('../../../utilities/GatsbyLink/index.js');
require('../../../primitives/Hero/Hero.js');
require('../../../primitives/HeroSrcSet/HeroSrcSet.js');
require('../../../primitives/Icon/Icon.js');
var Link = require('../../../primitives/Link/Link.js');
var useIsOverflow = require('../../../utilities/hooks/useIsOverflow.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var MediaListItem = function MediaListItem(props) {
  var btnTitle = props.btnTitle,
    children = props.children,
    className = props.className,
    empty = props.empty,
    href = props.href,
    hasMedia = props.hasMedia,
    subtitle = props.subtitle,
    title = props.title,
    sectionTitle = props.sectionTitle,
    showReadMoreBtn = props.showReadMoreBtn,
    standard = props.standard,
    openModal = props.openModal;
  var subtitleRef = React.useRef();
  var isOverflow = standard && useIsOverflow.useIsOverflow(subtitleRef);
  var _useState = React.useState(false),
    _useState2 = slicedToArray.default(_useState, 2),
    openSubtitle = _useState2[0],
    setOpenSubtitle = _useState2[1];
  var contentHeight = isOverflow === null || isOverflow === void 0 ? void 0 : isOverflow.height;
  var classes = index.default('lanl-media-list-item', isOverflow.overflow && 'subtitle-overflow', openSubtitle && 'subtitle--open', !hasMedia && 'full-width-text-dev', className);
  var renderTitle = function renderTitle() {
    return title && !empty && href ? /*#__PURE__*/React__default.default.createElement(index$1.default, {
      href: href,
      className: "title"
    }, title) : /*#__PURE__*/React__default.default.createElement("div", {
      className: "title"
    }, title);
  };
  var renderSubtitle = function renderSubtitle() {
    return subtitle && !empty && href ? /*#__PURE__*/React__default.default.createElement(index$1.default, {
      href: href,
      className: "subtitle"
    }, subtitle) : /*#__PURE__*/React__default.default.createElement("div", {
      className: "subtitle",
      ref: subtitleRef
    }, subtitle, /*#__PURE__*/React__default.default.createElement("button", {
      type: "button",
      className: "read-more",
      onClick: function onClick() {
        return setOpenSubtitle(!openSubtitle);
      }
    }, "...read ", openSubtitle ? 'less' : ' more'));
  };
  var renderReadMore = function renderReadMore() {
    return !empty && (openModal || href) && /*#__PURE__*/React__default.default.createElement(React__default.default.Fragment, null, href ? /*#__PURE__*/React__default.default.createElement(Link.Link, {
      href: href,
      className: "link"
    }, btnTitle, /*#__PURE__*/React__default.default.createElement("span", {
      className: "sr-only"
    }, "about the article: ", title)) : /*#__PURE__*/React__default.default.createElement("div", {
      className: "link",
      onClick: openModal,
      onKeyDown: openModal,
      role: "button",
      tabIndex: 0
    }, /*#__PURE__*/React__default.default.createElement("span", {
      className: "lanl-link"
    }, btnTitle, " ", /*#__PURE__*/React__default.default.createElement("span", {
      className: "sr-only"
    }, "about: ", title), /*#__PURE__*/React__default.default.createElement(arrow_right_inline.default, {
      className: "link-arrow"
    }))));
  };
  var renderStandard = function renderStandard() {
    return standard ? /*#__PURE__*/React__default.default.createElement(React__default.default.Fragment, null, sectionTitle && /*#__PURE__*/React__default.default.createElement("h3", {
      className: "section-title"
    }, sectionTitle), /*#__PURE__*/React__default.default.createElement("div", {
      className: "content",
      style: openSubtitle && hasMedia ? {
        height: "calc(50px + ".concat(contentHeight, "px + 30px)")
      } : null
    }, hasMedia && /*#__PURE__*/React__default.default.createElement("div", {
      className: "media-container",
      "data-testid": "media-container"
    }, children), /*#__PURE__*/React__default.default.createElement("div", {
      className: "div-title"
    }, renderTitle()), /*#__PURE__*/React__default.default.createElement("div", {
      className: "div-text"
    }, /*#__PURE__*/React__default.default.createElement("div", {
      className: "div-text-body"
    }, renderSubtitle(), showReadMoreBtn && renderReadMore(), !hasMedia && children && /*#__PURE__*/React__default.default.createElement("div", {
      className: "div-children"
    }, children))))) : children;
  };
  return /*#__PURE__*/React__default.default.createElement("li", {
    className: classes,
    "data-testid": "lanl-media-list-item"
  }, renderStandard());
};
MediaListItem.defaultProps = {
  btnTitle: 'Read Now',
  hasMedia: true,
  standard: true,
  showReadMoreBtn: true
};
MediaListItem.propTypes = {
  children: PropTypes__default.default.node.isRequired,
  btnTitle: PropTypes__default.default.string,
  className: PropTypes__default.default.string,
  empty: PropTypes__default.default.bool,
  hasMedia: PropTypes__default.default.bool,
  href: PropTypes__default.default.string,
  openModal: PropTypes__default.default.func,
  sectionTitle: PropTypes__default.default.string,
  showReadMoreBtn: PropTypes__default.default.bool,
  standard: PropTypes__default.default.bool,
  subtitle: PropTypes__default.default.string,
  title: PropTypes__default.default.string
};

exports.MediaListItem = MediaListItem;
exports.default = MediaListItem;
//# sourceMappingURL=MediaListItem.js.map
